<i18n
  src="@/locales/views/service_provider/tech_visit/producer_inspectors/new_producer_inspector.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/producer_inspector.yml" lang="yaml"></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :name="routeName('')"
    :params="{
      service_provider_id: service_provider_id,
      inspector_id: inspector_id,
    }"
  />
  <bread-crumbs :labels="[module_name, inspector.name]"></bread-crumbs>

  <alert-danger :errors_data="std_err" />

  <div v-if="load_general_data" class="mt-8">
    <div class="panel">
      <div class="panel-header">
        <h3 class="panel-header-title">
          {{ $t("labels.title") }}
        </h3>
      </div>

      <div class="panel-body">
        <div class="space-y-6">
          <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-6">
              <label class="label-form">
                {{ $t("model.producer_inspector.producer") }}
              </label>
              <div class="mt-1">
                <select-form
                  :options="producers"
                  v-model="producer_inspector.producer_id"
                  :is_invalid="isInvalidSelect('producer')"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="panel-footer">
        <div class="panel-footer-actions">
          <white-button
            @click.prevent="goToListProducers"
            :label="$t('labels.cancel_button')"
          />
          <span class="space-actions"></span>
          <success-button
            v-if="!proc_save_button"
            @click.prevent="create"
            :label="$t('labels.save_button')"
          />
          <success-button-processing v-else :label="$t('labels.save_button')" />
        </div>
      </div>
    </div>
  </div>

  <loading-message v-else />
</template>

<script>
import Requester from "@/views/service_provider/requesters/tech_visits/producer_inspectors/manage_producer_inspectors.js";

export default {
  name: "SPTechVisitProducerInspectorNewProducerInspector",
  data() {
    return {
      load_general_data: false,
      proc_save_button: false,
      inspector: {},
      producers: [],
      producer_inspector: {
        producer_id: null,
      },
    };
  },
  props: {
    service_provider_id: { required: true },
    inspector_id: { required: true },
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          service_provider_id: this.service_provider_id,
        },
      }).then(() => this.loadData())
    );
  },
  methods: {
    loadData: async function () {
      this.fetchInspector();
      this.fetchProducers();
      this.load_general_data = true;
    },

    fetchInspector: async function () {
      let response = await Requester.fetchInspector(
        this.service_provider_id,
        this.inspector_id
      );

      this.inspector = response.data;
    },

    fetchProducers: async function () {
      let { data } = await Requester.fetchProducers(
        this.service_provider_id,
        this.inspector_id
      );

      data.forEach((producer) => {
        producer.name = `${producer.organization_producer_code} - ${producer.producer_code} - ${producer.fullname}`;
      });

      this.producers = data;
    },

    create: async function () {
      this.proc_save_button = true;
      try {
        let response = await Requester.create(
          this.service_provider_id,
          this.inspector_id,
          this.producer_inspector
        );

        this.registerSuccessNotification({
          title: response.data.success_message,
        });
        this.goToListProducers();
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields,
          });
        }
        this.proc_save_button = false;
      }
    },
    goToListProducers: function () {
      this.$router.push({
        name: this.routeName(""),
        params: {
          service_provider_id: this.service_provider_id,
        },
      });
    },
  },
};
</script>
